type MobileColumnHeaderInfoBtnText = {
  ariaLabel?: string;
};

export interface MobileResourceTableInfoButtonProps {
  text: MobileColumnHeaderInfoBtnText;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLButtonElement>) => void;
}
export const MobileColumnHeaderInfoButton = ({
  text,
  onClick,
  onKeyDown,
}: MobileResourceTableInfoButtonProps): JSX.Element => {
  return (
    <button
      className="resourceTableHeaderIconBtn"
      onClick={onClick}
      tabIndex={0}
      aria-label={text.ariaLabel}
      onKeyDown={onKeyDown}
    >
      <i
        aria-hidden="true"
        className="fa-solid fa-info-circle resourceTableHeaderIcon"
      ></i>
    </button>
  );
};
